import * as api from './index';

export function getAdminDashboard() {
    return api.get('/admin/dashboard');
}
